import React from 'react';
import { 
  Users, 
  Award, 
  BookOpen, 
  Target, 
  Star, 
  TrendingUp, 
  Shield, 
  Globe, 
  Rocket, 
  Cog, 
  Building, 
  Cpu, 
  Palette, 
  Wrench, 
  Database, 
  CheckCircle, 
  ArrowRight 
} from 'lucide-react';
import '../Css_files/Internship_c1.css';


function Internship_c1() {
  return (
    <div className="intern-page">
      {/* Hero Section */}
      <section className="intern-hero-section">
        <div className="intern-geometric-bg">
          <div className="intern-shape intern-circle-1"></div>
          <div className="intern-shape intern-circle-2"></div>
          <div className="intern-shape intern-triangle-1"></div>
          <div className="intern-shape intern-triangle-2"></div>
          <div className="intern-shape intern-square-1"></div>
          <div className="intern-shape intern-hexagon-1"></div>
        </div>
        
        <div className="intern-hero-content">
          <div className="intern-logo-showcase">
            <div className="intern-logo-orbit">
              <div className="intern-logo-center">
                <Cog className="intern-logo-main" />
              </div>
              <div className="intern-orbit-item intern-orbit-1">
                <Building className="intern-orbit-icon" />
              </div>
              <div className="intern-orbit-item intern-orbit-2">
                <Cpu className="intern-orbit-icon" />
              </div>
              <div className="intern-orbit-item intern-orbit-3">
                <Palette className="intern-orbit-icon" />
              </div>
            </div>
          </div>
          
          <div className="intern-hero-text">
            <h1 className="intern-hero-title">
              <span className="intern-title-line">Learn Without Limits</span>
              <span className="intern-title-highlight">Anywhere, Anytime</span>
              <span className="intern-title-line">With Online Learning</span>
            </h1>
            <p className="intern-hero-subtitle">
              Gain in-demand skills and knowledge through our online learning platform. 
              Explore diverse fields, learn from industry experts, and build your career at your own pace.
            </p>
          </div>
          
          <div className="intern-hero-metrics">
            <div className="intern-metric-card">
              <div className="intern-metric-icon">
                <Users />
              </div>
              <div className="intern-metric-data">
                <span className="intern-metric-number">200K+</span>
                <span className="intern-metric-label">Active Learners</span>
              </div>
            </div>
            <div className="intern-metric-card">
              <div className="intern-metric-icon">
                <TrendingUp />
              </div>
              <div className="intern-metric-data">
                <span className="intern-metric-number">92%</span>
                <span className="intern-metric-label">Career Growth Rate</span>
              </div>
            </div>
            <div className="intern-metric-card">
              <div className="intern-metric-icon">
                <Award />
              </div>
              <div className="intern-metric-data">
                <span className="intern-metric-number">1,200+</span>
                <span className="intern-metric-label">Expert Instructors</span>
              </div>
            </div>
          </div>
          
          <div className="intern-hero-actions">
            <button className="intern-btn intern-btn-primary">
              <span>Browse Courses</span>
              <ArrowRight className="intern-btn-arrow" />
            </button>
            <button className="intern-btn intern-btn-outline">
              <span>Free Demo Class</span>
            </button>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="intern-process-section">
        <div className="intern-container">
          <div className="intern-section-header">
            <h2 className="intern-section-title">Your Online Learning Journey</h2>
            <p className="intern-section-subtitle">Four simple steps to success in any subject</p>
          </div>
          
          <div className="intern-process-flow">
            <div className="intern-process-card intern-card-discover">
              <div className="intern-card-number">01</div>
              <div className="intern-card-icon">
                <Target />
              </div>
              <h3 className="intern-card-title">Choose Your Path</h3>
              <p className="intern-card-description">
                Select from technology, business, design, arts, and more. Find the learning path that matches your career goals.
              </p>
              <div className="intern-card-features">
                <div className="intern-feature-tag">Wide Range of Subjects</div>
                <div className="intern-feature-tag">Skill Assessment</div>
                <div className="intern-feature-tag">Career Guidance</div>
              </div>
            </div>

            <div className="intern-process-card intern-card-learn">
              <div className="intern-card-number">02</div>
              <div className="intern-card-icon">
                <BookOpen />
              </div>
              <h3 className="intern-card-title">Learn from Experts</h3>
              <p className="intern-card-description">
                Access video lessons, interactive quizzes, and assignments taught by industry professionals.
              </p>
              <div className="intern-card-features">
                <div className="intern-feature-tag">Video Lectures</div>
                <div className="intern-feature-tag">Assignments</div>
                <div className="intern-feature-tag">Interactive Quizzes</div>
              </div>
            </div>

            <div className="intern-process-card intern-card-create">
              <div className="intern-card-number">03</div>
              <div className="intern-card-icon">
                <Cog />
              </div>
              <h3 className="intern-card-title">Practice & Apply</h3>
              <p className="intern-card-description">
                Work on real-world projects and case studies to apply your knowledge and build your portfolio.
              </p>
              <div className="intern-card-features">
                <div className="intern-feature-tag">Hands-on Projects</div>
                <div className="intern-feature-tag">Portfolio Development</div>
                <div className="intern-feature-tag">Peer Reviews</div>
              </div>
            </div>

            <div className="intern-process-card intern-card-launch">
              <div className="intern-card-number">04</div>
              <div className="intern-card-icon">
                <Rocket />
              </div>
              <h3 className="intern-card-title">Achieve Your Goals</h3>
              <p className="intern-card-description">
                Earn certificates, showcase your skills, and unlock new career opportunities in your chosen field.
              </p>
              <div className="intern-card-features">
                <div className="intern-feature-tag">Verified Certificates</div>
                <div className="intern-feature-tag">Job-Ready Skills</div>
                <div className="intern-feature-tag">Career Growth</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="intern-benefits-section">
        <div className="intern-container">
          <div className="intern-section-header">
            <h2 className="intern-section-title">Why Learn With Us?</h2>
            <p className="intern-section-subtitle">Designed for modern learners everywhere</p>
          </div>
          
          <div className="intern-benefits-mosaic">
            <div className="intern-benefit-tile intern-tile-large">
              <div className="intern-tile-content">
                <div className="intern-tile-icon">
                  <Shield />
                </div>
                <h3>Certified Courses</h3>
                <p>Get globally recognized certificates that add value to your resume and LinkedIn profile.</p>
                <div className="intern-tile-highlight">Globally Accepted</div>
              </div>
            </div>

            <div className="intern-benefit-tile intern-tile-medium">
              <div className="intern-tile-content">
                <div className="intern-tile-icon">
                  <Wrench />
                </div>
                <h3>Practical Learning</h3>
                <p>Engage with real-world projects, coding labs, and design tasks to master practical skills.</p>
              </div>
            </div>

            <div className="intern-benefit-tile intern-tile-medium">
              <div className="intern-tile-content">
                <div className="intern-tile-icon">
                  <Users />
                </div>
                <h3>Expert Mentors</h3>
                <p>Learn directly from experienced professionals and industry leaders.</p>
              </div>
            </div>

            <div className="intern-benefit-tile intern-tile-small">
              <div className="intern-tile-content">
                <div className="intern-tile-icon">
                  <Database />
                </div>
                <h3>Portfolio Ready</h3>
                <p>Complete projects that can be showcased in your portfolio to future employers.</p>
              </div>
            </div>

            <div className="intern-benefit-tile intern-tile-small">
              <div className="intern-tile-content">
                <div className="intern-tile-icon">
                  <Globe />
                </div>
                <h3>Global Community</h3>
                <p>Collaborate with learners and professionals from around the world.</p>
              </div>
            </div>

            <div className="intern-benefit-tile intern-tile-wide">
              <div className="intern-tile-content">
                <div className="intern-tile-icon">
                  <TrendingUp />
                </div>
                <h3>Career Growth Support</h3>
                <p>Get career coaching, resume building help, and interview preparation guidance.</p>
                <div className="intern-tile-stats">
                  <span>95% Job Readiness</span>
                  <span>Boost Your Earning Potential</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="intern-testimonials-section">
        <div className="intern-container">
          <div className="intern-section-header">
            <h2 className="intern-section-title">Success Stories</h2>
            <p className="intern-section-subtitle">Learners achieving their dreams with us</p>
          </div>
          
          <div className="intern-testimonials-grid">
            <div className="intern-testimonial-card intern-card-featured">
              <div className="intern-testimonial-header">
                <div className="intern-testimonial-avatar">
                  <div className="intern-avatar-placeholder">M</div>
                </div>
                <div className="intern-testimonial-info">
                  <h4>Maria Lopez</h4>
                  <p>Data Analyst at Google</p>
                  <div className="intern-testimonial-rating">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="intern-star-filled" />
                    ))}
                  </div>
                </div>
              </div>
              <blockquote className="intern-testimonial-quote">
                "The data science courses were clear, practical, and project-based. Within months, I landed my dream job at Google."
              </blockquote>
              <div className="intern-testimonial-impact">
                <span className="intern-impact-metric">Hired at Google</span>
                <span className="intern-impact-metric">Job Ready</span>
              </div>
            </div>

            <div className="intern-testimonial-card">
              <div className="intern-testimonial-header">
                <div className="intern-testimonial-avatar">
                  <div className="intern-avatar-placeholder">D</div>
                </div>
                <div className="intern-testimonial-info">
                  <h4>David Kumar</h4>
                  <p>Software Developer at Infosys</p>
                  <div className="intern-testimonial-rating">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="intern-star-filled" />
                    ))}
                  </div>
                </div>
              </div>
              <blockquote className="intern-testimonial-quote">
                "The online coding bootcamp was exactly what I needed. I improved my skills and cracked my Infosys interview."
              </blockquote>
            </div>

            <div className="intern-testimonial-card">
              <div className="intern-testimonial-header">
                <div className="intern-testimonial-avatar">
                  <div className="intern-avatar-placeholder">S</div>
                </div>
                <div className="intern-testimonial-info">
                  <h4>Sarah Lee</h4>
                  <p>UX Designer at Adobe</p>
                  <div className="intern-testimonial-rating">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="intern-star-filled" />
                    ))}
                  </div>
                </div>
              </div>
              <blockquote className="intern-testimonial-quote">
                "The design courses blended creativity with practical tools. I built a strong portfolio and now work at Adobe."
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="intern-cta-section">
        <div className="intern-container">
          <div className="intern-cta-content">
            <div className="intern-cta-visual">
              <div className="intern-cta-icon-grid">
                <div className="intern-cta-icon-item">
                  <Cog />
                </div>
                <div className="intern-cta-icon-item">
                  <Building />
                </div>
                <div className="intern-cta-icon-item">
                  <Cpu />
                </div>
                <div className="intern-cta-icon-item">
                  <Palette />
                </div>
              </div>
            </div>
            <div className="intern-cta-text">
              <h2 className="intern-cta-title">Start Learning Today</h2>
              <p className="intern-cta-description">
                Join thousands of learners worldwide and master skills in technology, business, design, and more. 
                Your online learning journey starts here.
              </p>
              <div className="intern-cta-actions">
                <button className="intern-btn intern-btn-primary intern-btn-large">
                  <span>Explore Courses</span>
                  <ArrowRight className="intern-btn-arrow" />
                </button>
                <button className="intern-btn intern-btn-ghost">
                  <span>Schedule Free Demo</span>
                </button>
              </div>
              <div className="intern-cta-guarantee">
                <CheckCircle className="intern-guarantee-icon" />
                <span>Certificate guarantee on completion</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Internship_c1;
